import { CSSProperties, Ref } from 'react'
import classNames from 'classnames'
import { Button } from '~/components/Button'
import { useAddToCart } from '~/hooks'
import { Product } from '~/types'
import AddToListButton from '../../../components/ProductCard/AddToListButton'
import { ProductDashboardQuantitySelector } from '../ProductDashboardQuantitySelector'
import styles from './ProductDashboardCartControls.module.css'

export interface ProductDashboardCartControlsProps {
  product: Product
  containerRef?: Ref<HTMLDivElement>
}

export const ProductDashboardCartControls = ({
  product,
  containerRef,
}: ProductDashboardCartControlsProps) => {
  const { sku } = product

  const { quantity, setQuantity, handleAddToCart, isLoading, latestQueryId } =
    useAddToCart(product)

  return (
    <div
      ref={containerRef}
      className={classNames(styles.root, 'mt-3 flex items-center gap-3')}>
      <ProductDashboardQuantitySelector
        product={product}
        quantity={quantity}
        onChange={setQuantity}
      />
      <Button
        className={classNames(styles.addToCartButton, 'flex-grow')}
        disabled={!sku}
        loading={isLoading}
        onClick={() => {
          handleAddToCart()
        }}>
        Add to Cart
      </Button>
      <AddToListButton
        product={product}
        queryId={latestQueryId}
        iconSize={20}
        className={styles.listBtn}
        buttonProps={{
          status: 'secondary',
          variant: 'solid',
          iconOnly: true,
          style: {
            '--btn-icon-size': '20px',
            width: '52px',
          } as CSSProperties,
        }}
      />
    </div>
  )
}
